<template>
    <div class="videoMessage">
        <video-player class="video-player-box" ref="videoPlayer" :options="playerOptions()" :playsinline="true">
        </video-player>
    </div>
</template>

<script>
import "video.js/dist/video-js.css";

import { videoPlayer } from "vue-video-player";
import _ from "lodash";
import log2 from "../../../utils/log2";

const log = log2("VideoMessage");
export default {
    name: "VideoMessage",
    components: {
        videoPlayer,
    },
    props: {
        data: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {};
    },
    methods: {
        videoSrc() {
            const asset = this.data.asset;
            const isWhatsapp = asset.path.indexOf("whatsapp") !== -1;
            const isInstagram = asset.path.indexOf("instagram") !== -1;
            const isTelegram = asset.path.indexOf("telegram") !== -1;
            const src =
                isWhatsapp || isInstagram || isTelegram
                    ? `https://static.supsis.live/${asset.path}`
                    : `https://static.supsis.live/${asset.path + asset._id + (asset.ext ? "." + asset.ext : "")}`;
            return src;
        },
        playerOptions() {
            const mime = _.get(this.data, "asset.mime", "video/mp4");
            return {
                // videojs options
                muted: false,
                language: this.$i18n.locale,
                playbackRates: [0.7, 1.0, 1.5, 2.0],
                sources: [
                    {
                        type: mime,
                        src: this.videoSrc(),
                    },
                ],
                poster: undefined,
                width: 300,
                height: 150,
            };
        },
    },
    mounted() {
        log("mounted", this.data);
    },
};
</script>

<style lang="scss" scoped>
.videoMessage {
    width: 300px;
    height: 159px;

    .video-js {
        width: 300px !important;
        height: 150px !important;
    }
}
</style>
